

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  IconButton,
  withStyles,
  withWidth,
  // isWidthUp,
} from "@material-ui/core";
import PhoneIcon from "@material-ui/icons/Phone";
import MailIcon from "@material-ui/icons/Mail";

const styles = (theme) => ({
  footerInner: {
    backgroundColor: theme.palette.common.darkBlack,
    // Provide consistent padding so content doesn't overflow on mobile
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(10),
      paddingLeft: theme.spacing(16),
      paddingRight: theme.spacing(16),
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
    },
  },
  infoIcon: {
    color: `${theme.palette.common.white} !important`,
    backgroundColor: "#33383b !important",
  },
});

const infos = [
  {
    icon: <PhoneIcon />,
    description: "+1 (925) 575 7459",
  },
  {
    icon: <MailIcon />,
    description: "support@hellowolfe.com",
  },
];

function Footer(props) {
  const { classes} = props;

  return (
    <footer>
      <div className={classes.footerInner}>
        {/* 
          Use a consistent spacing for both mobile & desktop. 
          For example, "4" gives enough room without huge gaps. 
        */}
        <Grid 
          container 
          spacing={4} 
          alignItems="flex-start"
        >
          {/* CONTACT DETAILS — ALWAYS VISIBLE */}
          <Grid item xs={12} md={4}>
            {/* Center them horizontally if you prefer; or use justifyContent="flex-start" */}
            <Box display="flex" justifyContent="center">
              <div>
                {infos.map((info, index) => (
                  <Box display="flex" mb={1} key={index}>
                    <Box mr={2}>
                      <IconButton
                        className={classes.infoIcon}
                        tabIndex={-1}
                        disabled
                      >
                        {info.icon}
                      </IconButton>
                    </Box>
                    <Box display="flex" flexDirection="column" justifyContent="center">
                      {/* 
                        MUI doesn't have "h7" by default. 
                        Use "body1" or "subtitle1" for normal text. 
                      */}
                      <Typography variant="body1" style={{ color: "#FFFFFF" }}>
                        {info.description}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </div>
            </Box>
          </Grid>

          {/* ABOUT THE COMPANY */}
          <Grid item xs={12} md={8}>
            {/* Add a little margin below the heading if it feels cramped */}
            <Typography
              variant="h6"
              style={{ color: "#FFFFFF", marginBottom: 8 }}
            >
              About the Company
            </Typography>
            {/* Remove extra left/right padding so it lines up nicely with the heading */}
            <Typography style={{ color: "#8f9296" }} paragraph>
              Wolfe is redefining mental health support through AI-driven,
              personalized interactions. Our mission is to bridge the gap
              in traditional therapy by making mental health care more
              accessible, intuitive, and stigma-free.
            </Typography>
          </Grid>
        </Grid>

          {/* TERMS AND POLICIES */}
          <Box mt={4} textAlign="center">
  <Typography variant="body2" style={{ color: "#8f9296" }}>
    <Link to="/privacy-policy" style={{ color: "#FFFFFF", textDecoration: "none" }}>Privacy Policy</Link> |
    <Link to="/terms-of-service-consumer" style={{ color: "#FFFFFF", textDecoration: "none", marginLeft: 10 }}>Terms of Service - Consumer</Link> |
    <Link to="/usage-policy" style={{ color: "#FFFFFF", textDecoration: "none", marginLeft: 10 }}>Usage Policy</Link>
  </Typography>
</Box>

      </div>
    </footer>
  );
}

Footer.propTypes = {
  width: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withWidth()(withStyles(styles, { withTheme: true })(Footer));



//this code below also works - its the main code for the footer, i only used the above because i wanted to center the contact details for mobile view

// import React from "react";
// import PropTypes from "prop-types";
// import {
//   Grid,
//   Typography,
//   Box,
//   IconButton,
//   Hidden,
//   withStyles,
//   withWidth,
//   isWidthUp,
//   // TextField
// } from "@material-ui/core";
// import PhoneIcon from "@material-ui/icons/Phone";
// import MailIcon from "@material-ui/icons/Mail";
// // import WaveBorder from "../../../shared/components/WaveBorder";
// import transitions from "@material-ui/core/styles/transitions";
// // import ColoredButton from "../../../shared/components/ColoredButton";

// const styles = theme => ({
//   footerInner: {
//     backgroundColor: theme.palette.common.darkBlack,
//     paddingTop: theme.spacing(8),
//     paddingLeft: theme.spacing(2),
//     paddingRight: theme.spacing(2),
//     paddingBottom: theme.spacing(6),
//     [theme.breakpoints.up("sm")]: {
//       paddingTop: theme.spacing(10),
//       paddingLeft: theme.spacing(16),
//       paddingRight: theme.spacing(16),
//       paddingBottom: theme.spacing(10)
//     },
//     [theme.breakpoints.up("md")]: {
//       paddingTop: theme.spacing(10),
//       paddingLeft: theme.spacing(10),
//       paddingRight: theme.spacing(10),
//       paddingBottom: theme.spacing(10)
//     }
//   },
//   brandText: {
//     fontFamily: "'Lato', sans-serif",
//     fontWeight: 400,
//     color: theme.palette.common.white
//   },
//   footerLinks: {
//     marginTop: theme.spacing(2.5),
//     marginBot: theme.spacing(1.5),
//     color: theme.palette.common.white
//   },
//   infoIcon: {
//     color: `${theme.palette.common.white} !important`,
//     backgroundColor: "#33383b !important"
//   },
//   socialIcon: {
//     fill: theme.palette.common.white,
//     backgroundColor: "#33383b",
//     borderRadius: theme.shape.borderRadius,
//     "&:hover": {
//       backgroundColor: theme.palette.primary.light
//     }
//   },
//   link: {
//     cursor: "Pointer",
//     color: theme.palette.common.white,
//     transition: transitions.create(["color"], {
//       duration: theme.transitions.duration.shortest,
//       easing: theme.transitions.easing.easeIn
//     }),
//     "&:hover": {
//       color: theme.palette.primary.light
//     }
//   },
//   whiteBg: {
//     backgroundColor: theme.palette.common.white
//   }
// });

// const infos = [
//   {
//     icon: <PhoneIcon />,
//     description: "+1 (925) 575 7459"
//   },
//   {
//     icon: <MailIcon />,
//     description: "support@hellowolfe.com"
//   }
// ];

// function Footer(props) {
//   const { classes, width } = props;
//   return (
//     <footer className="lg-p-top">
//       <div className={classes.footerInner}>
//         <Grid container spacing={isWidthUp("md", width) ? 10 : 5}>
    
//             <Grid item xs={12} md={4} lg={4} style={{padding:0}}>
//               <Box display="flex" justifyContent="center">
//                 <div>
//                   {infos.map((info, index) => (
//                     <Box display="flex" mb={1} key={index}>
//                       <Box mr={2}>
//                         <IconButton className={classes.infoIcon} tabIndex={-1} disabled>
//                           {info.icon}
//                         </IconButton>
//                       </Box>
//                       <Box display="flex" flexDirection="column" justifyContent="center">
//                         <Typography variant="h7"  style={{ color: "#FFFFFF" }}>
//                           {info.description}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   ))}
//                 </div>
//               </Box>
//             </Grid>
          

//           <Grid item xs={12} md={8} lg={4} style={{padding:0}}>
//             <Typography variant="h6" paragraph className="text-white">
//               About the Company
//             </Typography>

//             <Typography style={{ color: "#8f9296", paddingLeft: 16,paddingRight: 16 }} paragraph>
//             Wolfe is redefining mental health support through AI-driven, personalized interactions. Our mission is to bridge the gap in traditional therapy by making mental health care more accessible, intuitive, and stigma-free.
//             </Typography>
//           </Grid>
//         </Grid>
//       </div>
//     </footer>
//   );
// }

// Footer.propTypes = {
//   theme: PropTypes.object.isRequired,
//   classes: PropTypes.object.isRequired,
//   width: PropTypes.string.isRequired
// };

// export default withWidth()(withStyles(styles, { withTheme: true })(Footer));
